<template>
	<div>
		<GeoLocation
            :height=500
            :lng="lng"
            :lat="lat"
            @onChangeMarker="(e) => setLocation(e)"
        ></GeoLocation>

        <label for="lat">Latitude</label>
        <input class="form-control" id="lat" placeholder="Latitude" v-model="lat">
        <hr/>
        <label for="lng">Longitude</label>
        <input class="form-control" id="lng" placeholder="Longitude" v-model="lng">
        <hr/>
        <button class="btn btn-info">Submit</button>
	</div>
</template>

<script>
    import GeoLocation from './../../../components/GeoLocation'
	export default {
        components: {
            GeoLocation
        },
        methods: {
            setLocation(e) {
                this.lat = e.lat;
                this.lng = e.lng;
            }
        },
		data() {
			return {
                lat: 31.22,
                lng: 30.22
            }
		}
	}
</script>
